import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import AllNDOTRequests from "../../../components/ndot/AllRequests";

const NDOTDepartmentalRequests = () => {
    const location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const queryParams = new URLSearchParams(location.search);
    
    const department = queryParams.get('label');
    const departmentslug = segments?.[2];

    return (
        <div className="ndot-requests">
            <div className="page-header">
                <div className="title">
                    <h1>NDOT Requests</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to='/nd-ot/my-request'>NDOT</NavLink>
                        </li>
                        <li>
                            <NavLink to="/nd-ot/all-requests">All Requests</NavLink>
                        </li>
                        <li>
                            <span>{department}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <AllNDOTRequests departmentslug={departmentslug} />
        </div>
    )
}

export default NDOTDepartmentalRequests;